// extracted by mini-css-extract-plugin
export var cartIcon = "_nx-0";
export var cartIconContainer = "_nx-1";